import { createContext } from 'react';
import type { RoleName, User } from '../../types/api';

export interface AuthState {
  user: User | null;
  /** Cierto mientras se intenta recuperar la sesion al cargar la aplicacion. */
  isBootstrapping: boolean;
  isAuthenticated: boolean;
  hasRole: (...roles: RoleName[]) => boolean;
  login: (email: string, password: string) => Promise<User>;
  logout: () => Promise<void>;
}

/**
 * El contexto vive en su propio archivo, sin componentes.
 *
 * Asi el modulo del proveedor exporta solo componentes y la recarga en caliente
 * de Vite no pierde el estado de la sesion en cada guardado.
 */
export const AuthContext = createContext<AuthState | null>(null);
